<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<!-- 轮播图 -->
			<el-carousel
				height="823px"
				indicator-position="none"
				arrow="never"
				v-if="detailsList.icon"
			>
				<el-carousel-item
					v-for="(item, index) in detailsList.icon.split('|')"
					:key="index"
				>
					<img style="width: 100%; height: 100%" :src="item" alt="" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 标题 -->
		<div class="title">
			<span>{{ detailsList.title }}</span>
		</div>
		<div class="box2">
			<div class="box-main">{{ detailsList.content }}</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'caseDetails',
	components: {
		navTop
	},
	data() {
		return {
			detailsList: {},
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			console.log(JSON.parse(this.$route.query.item));
			this.detailsList=JSON.parse(this.$route.query.item)
		}
	},
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		margin: 50px auto 0;
	}
	.title {
		margin-top: 44px;
		width: 100%;
		height: 131px;
		background-image: url(../../assets/details-title.png);
		background-size: 100% 100%;
		span {
			margin: 0 auto;
			height: 87px;
			display: block;
			text-align: center;
			font-size: 40px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #00fcff;
			line-height: 87px;
			padding-right: 70px;
			box-sizing: border-box;
		}
	}
	.box2 {
		margin: 0 auto;
		padding-bottom: 200px;
		box-sizing: border-box;
		// 内容
		.box-main {
			width: 100%;
			height: 631px;
			border-radius: 38px;
			background-image: url(../../assets/cancel.png);
			background-size: 100% 100%;
			padding: 140px 65px 15px 138px;
			box-sizing: border-box;
			font-size: 24px;
			color: #00fff0;
			line-height: 48px;
			margin-top: 57px;
		}
	}
}
</style>
